import React from 'react';
import { connect } from 'react-redux';


const ConvenienceFeeNote = ({
  className,
  showConvenienceFee,
}) => (
  showConvenienceFee ?
  <div
    className={className ? className : 'push--bottom text-light-grey center'}
    style={{ fontSize: '14px' }}>
    Nominal convenience fee applicable
  </div> :
  null
);

const mapStateToProps = ({
  cart,
  settings,
}) => ({
  showConvenienceFee: cart ? cart.settings.showConvenienceFee : settings.showConvenienceFee,
});

export default connect(mapStateToProps)(ConvenienceFeeNote);



// WEBPACK FOOTER //
// ./src/payments/views/convenience-fee/ConvenienceFeeNote.js